<!-- 绑定公众号 -->
<template>
  <div></div>
</template>

<script>
import qs from "qs";
export default {
  name: "transitPage",
  components: {},

  data() {
    return {
    };
  },
  computed: {},
  mounted() {
    // ?account=13523451691&account_id=201&account_name=河南新盛捷有限公司&enterprisePhoto=http://work-1302521284.cos.ap-beijing.myqcloud.com/weijub/QQ%E6%88%AA%E5%9B%BE20211013154526.png&examineCode=039916cc56a186a18016158929053b32&id=228&password=f379eaf3c831b04de153469d1bec345e&past_time=2021-11-10 16:37:54&phone=13523451691&role_id=0&usertoken=be4e321bf67bea3e6dda0cea6bd38ead201
    // this.getUrlKey()
    this.transit()
  },

  methods: {
    // getUrlKey(keyname, url) {
    //     return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
    // },
    transit() {
        var url = location.href;
        const href = url;
        const params = href.split('?')[1]
        // const code = 'https://api.weijub.com/crm/WeChatNotify/notify?account_id=' + params;
        window.location = 'https://api.weijub.com/crm/WeChatNotify/notify?account_id=' + params;
    },
  },
};
</script>
<style  lang="scss" scoped>
</style>